import React from "react";
import { BrowserRouter } from "react-router-dom";

import { MuiThemeProvider, withTheme } from "@material-ui/core/styles";

import {
  FleetState,
  OtaState,
  RiderState,
  DeploymentState,
  PromoState,
  SnackbarContextProvider,
  VehicleState,
} from "./context";
import Router from "./routers/Router";
import spTheme from "./spTheme";

const App = () => (
  <MuiThemeProvider theme={spTheme}>
    <BrowserRouter>
      <SnackbarContextProvider>
        <FleetState>
          <VehicleState>
            <OtaState>
              <RiderState>
                <DeploymentState>
                  <PromoState>
                    <Router />
                  </PromoState>
                </DeploymentState>
              </RiderState>
            </OtaState>
          </VehicleState>
        </FleetState>
      </SnackbarContextProvider>
    </BrowserRouter>
  </MuiThemeProvider>
);

export default withTheme(App);
export { App };
